import { fetchProspectApplicationFile } from '../services/tenantApi';

export interface CachedProspectDocument {
  blob: Blob;
  objectUrl: string;
}

const stored = new Map<string, CachedProspectDocument>();
const inFlight = new Map<string, Promise<CachedProspectDocument>>();

/** Already fetched file, if this session has loaded it. */
export function cachedProspectDocument(documentId: string): CachedProspectDocument | null {
  return stored.get(documentId) ?? null;
}

/**
 * Load a private application file once per session.
 * Later calls reuse the same blob so the file endpoint is not hit again.
 */
export function loadProspectDocument(
  getToken: () => Promise<string>,
  documentId: string,
): Promise<CachedProspectDocument> {
  const hit = stored.get(documentId);
  if (hit) return Promise.resolve(hit);
  const pending = inFlight.get(documentId);
  if (pending) return pending;

  const request = fetchProspectApplicationFile(getToken, documentId)
    .then((blob) => {
      const file: CachedProspectDocument = { blob, objectUrl: URL.createObjectURL(blob) };
      stored.set(documentId, file);
      inFlight.delete(documentId);
      return file;
    })
    .catch((error: unknown) => {
      inFlight.delete(documentId);
      throw error;
    });
  inFlight.set(documentId, request);
  return request;
}
